import React from "react";
import { Link } from "react-router-dom";
import LEARN_ARTICLES from "../../data/learnArticles";
import "./Learn.css";

const CATEGORY_ORDER = [
  "Technology",
  "Mode",
  "Voltage",
  "Temperature",
  "Backlight",
  "Interface",
  "Compliance",
  "Customization",
];

const LearnHubPage = () => {
  const groups = CATEGORY_ORDER.map((category) => ({
    category,
    articles: LEARN_ARTICLES.filter((a) => a.category === category),
  })).filter((g) => g.articles.length > 0);

  return (
    <div className="learn-detail-container learn-hub-container">
      <header className="learn-header">
        <div className="learn-header-inner">
          <nav className="learn-breadcrumb">
            <Link to="/" className="learn-breadcrumb-link">Home</Link>
            <span className="learn-breadcrumb-sep">/</span>
            <span className="learn-breadcrumb-current">Learn</span>
          </nav>

          <span className="learn-category-badge">SEGMENTED LCD KNOWLEDGE BASE</span>
          <h1 className="learn-title">Segmented LCD Learning Center</h1>
          <p className="learn-summary">
            Everything that goes into a custom segmented LCD spec -- display
            technology, viewing modes, drive voltage, backlighting and more --
            explained in plain terms, with the pros, cons and best-fit
            application for each option.
          </p>
        </div>
      </header>

      <div className="learn-content-wrapper">
        <div className="learn-content">
          {groups.map((g) => (
            <section className="learn-hub-group" key={g.category}>
              <h2 className="learn-hub-group-title">{g.category}</h2>
              <div className="learn-hub-grid">
                {g.articles.map((a) => (
                  <Link to={`/learn/${a.slug}`} key={a.slug} className="learn-hub-card">
                    <h3>{a.heading}</h3>
                    <p>{a.summary}</p>
                    <span className="learn-hub-card-cta">Read more →</span>
                  </Link>
                ))}
              </div>
            </section>
          ))}

          <div className="learn-cta">
            <h3 className="learn-cta-title">Ready to Spec Your Own Segmented LCD?</h3>
            <p className="learn-cta-desc">
              Every BIBA segmented display is engineered from a blank sheet
              around your product -- the layout, icons and connector are
              drawn to match your exact requirement.
            </p>
            <div className="learn-cta-actions">
              <Link to="/category/passive-displays/segmented-display" className="learn-btn-outline">
                View Segmented LCD Displays
              </Link>
              <a href="/contact#rfq" className="learn-btn-solid">Get a Quote</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LearnHubPage;
